// extracted by css-extract-rspack-plugin
export default {"emailBody":"ProgramOutcomeEmails_emailBody__LgIn3"};